import React from "react";
import { Input, TextArea } from "semantic-ui-react";
import { AppointmentPhasePicker, LabelledRow } from "../../../components";
import { type FlightEditProps } from "../../model";
import ArtistSelection from "./artistselection";
import TravellersRow from "./travellersrow";

interface Props {
  flight: FlightEditProps
  onFlightEdit: (props: FlightEditProps) => void
  noArtistError: boolean
}

export default class GeneralFlightEdit extends React.Component<Props> {
  onFlightEdit = (props: Partial<FlightEditProps>) => {
    // Merge the changes with the existing props
    const newProps = { ...this.props.flight, ...props };
    this.props.onFlightEdit(newProps);
  };

  public render(): JSX.Element {
    const { phase, artist, travellers, bookingCode, travelAgency, notes } = this.props.flight;

    return <table className="s1_table bordergrid gray">
      <tbody>
        <tr>
          <td className="label">{RESX.Status.resxStatus}</td>
          <td className="padding" colSpan={2}>
            <AppointmentPhasePicker
              value={phase}
              onChange={newPhase => { this.onFlightEdit({ phase: newPhase }); }}
            />
          </td>
        </tr>

        <LabelledRow label={site.currentEnvironment.functionGroups.artist.singular}>
          <ArtistSelection
            noArtistError={this.props.noArtistError}
            artist={artist}
            onArtistSelected={newArtist => { this.onFlightEdit({ artist: newArtist, travellers: newArtist == null ? null : travellers }); }}
          />
        </LabelledRow>

        <TravellersRow
          artist={artist}
          travellers={travellers}
          onTravellersChanged={selectedTravellers => { this.onFlightEdit({ travellers: selectedTravellers }); }}
        />

        <LabelledRow label={RESX.Flight.BookingCode}>
          <Input
            fluid
            type="text"
            maxLength={serverReference.constants.flight.maxBookingCodeLength}
            onChange={(_, { value }) => { this.onFlightEdit({ bookingCode: value }); }}
            value={bookingCode ?? ""} />
        </LabelledRow>
        <LabelledRow label={RESX.Flight.TravelAgency}>
          <Input
            fluid
            type="text"
            maxLength={serverReference.constants.flight.maxTravelAgencyLength}
            onChange={(_, { value }) => { this.onFlightEdit({ travelAgency: value }); }}
            value={travelAgency ?? ""} />
        </LabelledRow>
        <LabelledRow label={RESX.Note.Notes}>
          <TextArea
            maxLength={serverReference.constants.flight.maxNotesLength}
            rows={3}
            onChange={(e) => { this.onFlightEdit({ notes: (e.target as any).value }); }}
            value={notes ?? ""} />
        </LabelledRow>
      </tbody>
    </table>;
  }
}
